import { Constants } from '@leverege/molten-core';
import RsrcAccessCreator from './RsrcAccessCreator.js';
// import SystemRsrcAccessCreator from './SystemRsrcAccessCreator.js'
import Analyzer from './Analyzer.js';
import OverlayImageViewer from "./OverlayImageViewer.js";
export default {
  install(molten) {
    molten.addPlugin(Constants.INITIALIZER, Analyzer);
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, RsrcAccessCreator);
    molten.addPlugin('ResourceImageViewer', OverlayImageViewer);
  }
};